import PageContainer from "../components/layout/PageContainer";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { useApi } from "../hooks/useApi";
import { useAuth } from "../hooks/useAuth";
import { accountApi } from "../api/account";
import { billingApi } from "../api/billing";
import { formatCurrency } from "../utils/format";

export default function Settings() {
  const { user } = useAuth();
  const account = useApi(() => accountApi.getInfo(), []);
  const balance = useApi(() => billingApi.getBalance(), []);

  if (account.loading) {
    return <LoadingSpinner message="Loading settings..." />;
  }

  const accountData = account.data?.data;
  const balanceData = balance.data?.data;

  return (
    <PageContainer
      title="Settings"
      description="Account configuration"
    >
      <div className="space-y-6">
        {/* Account info */}
        <div className="rounded-lg border border-gray-200 bg-white p-6">
          <h2 className="mb-4 text-sm font-medium text-gray-900">
            Account Information
          </h2>
          <dl className="space-y-3">
            {user?.email && (
              <div className="flex items-center justify-between">
                <dt className="text-sm text-gray-500">Email</dt>
                <dd className="text-sm font-medium text-gray-900">
                  {user.email}
                </dd>
              </div>
            )}
            {accountData?.name && (
              <div className="flex items-center justify-between">
                <dt className="text-sm text-gray-500">Account Name</dt>
                <dd className="text-sm font-medium text-gray-900">
                  {accountData.name}
                </dd>
              </div>
            )}
            {accountData?.id && (
              <div className="flex items-center justify-between">
                <dt className="text-sm text-gray-500">Account ID</dt>
                <dd className="font-mono text-sm text-gray-900">
                  {accountData.id}
                </dd>
              </div>
            )}
          </dl>
          {account.error && (
            <p className="mt-3 text-sm text-amber-600">
              Unable to load account details: {account.error}
            </p>
          )}
        </div>

        {/* Balance alert threshold */}
        <div className="rounded-lg border border-gray-200 bg-white p-6">
          <h2 className="mb-4 text-sm font-medium text-gray-900">
            Billing
          </h2>
          <dl className="space-y-3">
            {balanceData && (
              <>
                <div className="flex items-center justify-between">
                  <dt className="text-sm text-gray-500">Current Balance</dt>
                  <dd className="text-sm font-medium text-gray-900">
                    {formatCurrency(balanceData.balance, balanceData.currency)}
                  </dd>
                </div>
                {balanceData.alertThreshold != null && (
                  <div className="flex items-center justify-between">
                    <dt className="text-sm text-gray-500">
                      Low Balance Alert Threshold
                    </dt>
                    <dd className="text-sm font-medium text-gray-900">
                      {formatCurrency(
                        balanceData.alertThreshold,
                        balanceData.currency,
                      )}
                    </dd>
                  </div>
                )}
              </>
            )}
            {balance.error && (
              <p className="text-sm text-amber-600">
                Unable to load balance: {balance.error}
              </p>
            )}
          </dl>
        </div>

        {/* Authentication info */}
        <div className="rounded-lg border border-gray-200 bg-white p-6">
          <h2 className="mb-4 text-sm font-medium text-gray-900">
            Authentication
          </h2>
          <p className="text-sm text-gray-600">
            You are authenticated via Cloudflare Access. Your session is
            managed by your identity provider.
          </p>
        </div>
      </div>
    </PageContainer>
  );
}
